export const AUTH_CARD_BUTTON_WIDTH = 348
export const MODAL_BUTTON_WIDTH = 392
